export type DescriptionSyncJobStatusValue =
  | 'running'
  | 'completed'
  | 'completed-with-issues'
  | 'failed'

export interface DescriptionSyncJobStatus {
  jobId: string
  accountId: string
  totalVehicles: number
  completedVehicles: number
  percentage: number
  phase: string
  status: DescriptionSyncJobStatusValue
}

export interface StartDescriptionSyncJobResponse {
  jobId: string
  status: DescriptionSyncJobStatusValue
}

export interface DescriptionSyncJobResult {
  vin: string
  status: string
  message?: string
}

export interface DescriptionSyncJobResultsPage {
  jobId: string
  page: number
  pageCount?: number
  results: DescriptionSyncJobResult[]
}

export type DescriptionSyncJobFailureKind =
  | 'unauthenticated'
  | 'forbidden'
  | 'conflict'
  | 'not-found'
  | 'unavailable'

export interface DescriptionSyncJobFailure {
  kind: DescriptionSyncJobFailureKind
  jobId?: string
}

const TERMINAL_STATUSES: ReadonlySet<DescriptionSyncJobStatusValue> = new Set([
  'completed',
  'completed-with-issues',
  'failed',
])

export const isDescriptionSyncTerminal = (status: unknown): boolean =>
  TERMINAL_STATUSES.has(status as DescriptionSyncJobStatusValue)

export const descriptionSyncProgressMessage = (
  job: DescriptionSyncJobStatus | null,
): string => {
  if (!job) return 'Starting description sync…'
  if (job.status === 'completed') return 'Description sync completed.'
  if (job.status === 'completed-with-issues') {
    return 'Description sync completed with issues.'
  }
  if (job.status === 'failed') return 'Description sync failed.'
  if (job.phase.trim().toLowerCase() === 'finalizing') return 'Finalizing descriptions…'
  return 'Running description sync…'
}
